import { LocaleCode } from '../../helpers';
import { Generic } from '../dictionary-service';
import { Status } from './external-credentials.interface';

export enum AiCvParserAccessLevel {
  NONE = 'none',
  CLASSIC = 'classic',
  FULL = 'openAiFull',
}

export interface SubscriptionInfo {
  plan: string;
  isActive: boolean;
  endDate: string | null;
}

export interface Features {
  aiCvParserAccess: AiCvParserAccessLevel;
  allowApplyFromPublicWebsite: boolean;
  canAddTeammates: boolean;
  daysToDeadline: number;
  searchDuplicatesInConsole: boolean;
  searchDuplicatesInDetails: boolean;
  searchDuplicatesInAts: boolean;
  recruiterCount: number;
}

export type Base = Generic.Item;

export interface Query {
  page: number;
  size: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  search: string;
}

export interface Details extends Base {
  createdAt: string;
  features: Features;
  subscription: SubscriptionInfo;
  jobBoardUrl: string | null;
  externalCredentials: Status[];
}

export interface CreatePayload {
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  locale: LocaleCode;
  jobBoardUrl: string | null;
  aiCvParserAccess: AiCvParserAccessLevel;
  subscription: string;
  endDate: Date | null;
}

export interface UpdatePayload extends Omit<
  CreatePayload,
  'email' | 'firstName' | 'lastName' | 'phone' | 'locale'
> {
  id: number;
  allowApplyFromPublicWebsite?: boolean;
  canAddTeammates?: boolean;
  daysToDeadline?: number;
  recruiterCount?: number;
  searchDuplicatesInAts?: boolean;
  searchDuplicatesInConsole?: boolean;
  searchDuplicatesInDetails?: boolean;
}
